module.exports = __webpack_public_path__ + "img/error-banner.c8122b3d.svg";